import { Capacitor, registerPlugin } from '@capacitor/core';

const StoreKit = registerPlugin('StoreKit');
const isNative = Capacitor.isNativePlatform();

export const getProducts = async () => {
  if (!isNative) {
    console.log('[StoreKit] Not native platform, skipping getProducts');
    return [];
  }
  try {
    console.log('[StoreKit] Fetching products...');
    const result = await StoreKit.getProducts();
    console.log('[StoreKit] Products result:', JSON.stringify(result));
    return result.products || [];
  } catch (error) {
    console.error('[StoreKit] getProducts error:', error);
    return [];
  }
};

export const getPremiumProduct = async () => {
  const products = await getProducts();
  return products.find(p => p.id === 'com.worthly.premium.monthly') || null;
};

export const purchasePremium = async () => {
  if (!isNative) {
    console.log('[StoreKit] Not native platform, skipping purchase');
    return { success: false, error: 'Not on native platform' };
  }
  try {
    console.log('[StoreKit] Starting purchase for com.worthly.premium.monthly...');
    const result = await StoreKit.purchase({ productId: 'com.worthly.premium.monthly' });
    console.log('[StoreKit] Purchase result:', JSON.stringify(result));
    return result;
  } catch (error) {
    console.error('[StoreKit] purchase error:', error.message, error);
    return { success: false, error: error.message || 'Purchase failed' };
  }
};

export const restorePurchases = async () => {
  if (!isNative) return { success: false, error: 'Not on native platform' };
  try {
    return await StoreKit.restorePurchases();
  } catch (error) {
    console.error('[StoreKit] restore error:', error);
    return { success: false, error: error.message || 'Restore failed' };
  }
};

export const getSubscriptionStatus = async () => {
  if (!isNative) return { active: false };
  try {
    return await StoreKit.getSubscriptionStatus();
  } catch (error) {
    console.error('[StoreKit] status error:', error);
    return { active: false };
  }
};
